<div class="d-flex flex-column col justify-content-center align-items-center mt-3">
  <p>{{ partTitle }} {{ part }}</p>
  <img [src]="getThumbnailPath()" class="img-fluid" [ngClass]="{ 'app-grey-out': finished }" style="max-width: 200px" />
  <h6 class="mt-3">{{ name }}</h6>
</div>
